import { IDonator } from './donator.interface';
import { ICharityPot } from './charity-pot.interface';

export class Subscription {
  id: number;
  amount: number;
  gift_creator: number;
  gift_gandee: number;
  service_fee: number;
  is_visible: boolean;
  is_main: boolean;
  is_anonymous: boolean;

  amount_formatted: string;
  created_at: string;
  updated_at: string;
  donated_by: IDonator;
  donated_to: ICharityPot;
  payment_info: Payment;
  pot_id: number;

  // transient
  donation_id: number;
  pot_status_formatted: string;

  // subscription
  recurrence: string;
  debit_day: number;
  status: any;
}
interface Payment {
  PaymentType: string;
  mandateID: string;
}



